import { render, staticRenderFns } from "./SetupGuideMobile.vue?vue&type=template&id=11954a5f&scoped=true&"
import script from "./SetupGuideMobile.vue?vue&type=script&lang=js&"
export * from "./SetupGuideMobile.vue?vue&type=script&lang=js&"
import style0 from "./SetupGuideMobile.vue?vue&type=style&index=0&id=11954a5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11954a5f",
  null
  
)

export default component.exports